/* HomeOSAvatar — round avatar with photo OR quiet Warm Stone initials.
   Room colours are identifiers, not decoration: every default initial
   avatar uses the Family Warm Stone tone (#7A6E63). */

const FAMILY_STONE = "#7A6E63";
const WARM_IVORY = "#FAF9F6";

const SIZE_CLASSES = {
  xs: "w-7 h-7 text-[10px]",
  sm: "w-9 h-9 text-xs",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-base",
  xl: "w-24 h-24 text-2xl",
};

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map(p => p.charAt(0).toUpperCase()).join("") || "?";
}

export function HomeOSAvatar({ member, size = "md", showRing = true, className = "" }) {
  const sz = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const photoUrl = member?.avatarType === "photo" ? member?.photoUrl : null;
  const initials = member?.initials || getInitials(member?.name);

  return (
    <div
      className={`${sz} relative rounded-full flex-shrink-0 ${className}`}
      style={showRing && photoUrl ? { boxShadow: `0 0 0 1px ${FAMILY_STONE}` } : undefined}
      data-testid={`homeos-avatar-${member?.id || "anon"}`}
    >
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={`${member?.name || "Member"} profile photo`}
          className="w-full h-full rounded-full object-cover"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      ) : (
        <div
          className="w-full h-full rounded-full flex items-center justify-center font-medium"
          style={{ backgroundColor: FAMILY_STONE, color: WARM_IVORY }}
        >
          {initials}
        </div>
      )}
    </div>
  );
}

export default HomeOSAvatar;
